<script lang="ts" setup>
import faqModelJSON from '~/../assets/faq_models/materials.json';
import FAQIndex from '~/components/FAQ/FAQIndex.vue';
const content = faqModelJSON as unknown as FAQMenuContent[];
</script>
<template>
  <FAQIndex :content="content" type="materials" router-articles="MaterialsArticles" />
</template>
